export default "__VITE_ASSET__CuB3HbV8__"